export let systomMenuList = [
  {
    img: require("@/assets/home/home_img_kaifang.png"),
    title: "开放遥感数据采集器",
    nickName: "Zimax CData",
    content:
      "Zimax CData开放遥感数据采集器，是中遥信息为用户专业打造的一站式开放卫星数据查询下载软件",
  },
  {
    img: require("@/assets/home/home_img_dashuju.png"),
    title: "遥感大数据智能管理平台",
    nickName: "Zimax MData",
    content:
      "Zimax MData遥感大数据智能管理平台，是对遥感影像数据和多源空间数据资源的集中式一体化高效管理平台",
  },
  {
    img: require("@/assets/home/home_img_yingxiang.png"),
    title: "遥感影像自动处理平台",
    nickName: "Zimax PData",
    content:
      "Zimax PData遥感影像数据自动处理平台，是为有遥感影像处理需求的用户提供的遥感数据影像加工处理和数据共享平台",
  },
  {
    img: require("@/assets/home/home_img_zhineng.png"),
    title: "智能遥感专题数据包",
    nickName: "Zimax IData",
    content:
      "Zimax IData智能遥感数据包，是直接为终端用户服务的业务化遥感监测数据产品",
  },
];

export let companyLogoList = [
  require("@/assets/cooperate/company1.png"),
  require("@/assets/cooperate/company2.png"),
  require("@/assets/cooperate/company3.png"),
  require("@/assets/cooperate/company4.png"),
  require("@/assets/cooperate/company5.png"),
  require("@/assets/cooperate/company6.png"),
  require("@/assets/cooperate/company7.png"),
  require("@/assets/cooperate/company8.png"),
  require("@/assets/cooperate/company9.png"),
  require("@/assets/cooperate/company10.png"),
];
